<template>
  <h1>404</h1>
</template>

<script>
  export default {
    name: "NotFound",
    metaInfo: {
      titleTemplate: '%s - Not Found'
    },
  }
</script>
